import { SVGProps } from "react";

export default function ArrowRightTriangleIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 12, width = 25, stroke = "black", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M24.2695 5.77344L14.2695 -6.53267e-05V11.5469L24.2695 5.77344ZM0 5.77344V6.77344H15.2695V5.77344V4.77344H0V5.77344Z"
        fill={stroke}
      />
    </svg>
  );
}
